<template>
    <span
        class="geofleet-wrapper geofleet-mobile print-directives"
        :class="{
            'menu-collapsed': main_menu_collapsed,
            'menu-extended': !main_menu_collapsed,
            'fullscreen-map': fullScreenMap
        }"
    >
        <golia-loader
            v-show="loading || rootLoading"
            :hideable="false"
            :message="loadingTimeout ? __('loading_timeout') : __('loading')"
        ></golia-loader>

        <div class="geofleet-map">
            <router-view name="map"></router-view>
        </div>

        <div class="panel-box">
            <transition name="common-fade">
                <router-view></router-view>
            </transition>
        </div>

        <config-saving-indicator />
    </span>
</template>

<script>
import moment from 'moment'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { mapConfig } from '@/composables/useConfig'

export default {
    name: 'GeoFleetMobile',
    components: {
        // Config Bus (Sprint 19): badge "salvataggio…" + toast d'errore post-rollback.
        ConfigSavingIndicator: () => import('@/components/commons/ConfigSavingIndicator.vue')
    },
    props: [],
    data() {
        return {
            loading: false,
            loadingTimeout: false,
            fullScreenMap: false,
            // REFACTOR-009: rimosso trucks_ref locale. Single source = state.geoFleet.trucks
            // via getter trucksMap (O(1) lookup) e storeTrucks (iterazione).
            drivers: [],
            profiles: [],
            proveniences: [],
            companies: [],
            pois: [],

            activity_panel: null,
            utility_panel: null,

            last_update: null,

            main_menu_collapsed: true
        }
    },
    computed: {
        blurredMap() {
            return (
                this.activity_panel !== null ||
                (this.utility_panel !== null &&
                    this.utility_panel != 'vehicles-passage' &&
                    this.utility_panel != 'trucks-with-alerts') ||
                // Here the open table always fills the screen — "Dynamic width"
                // is ignored on mobile — so it always hides the map.
                (this.vehicleListModeView == 'table' && !this.$store.state.panels.main.collapsed)
            )
        },
        // Sprint 19: reader granulari dal Config Bus.
        ...mapConfig(['vehicleListModeView']),
        ...mapState({
            rootLoading: (state) => state.rootLoading
            // REFACTOR-007 (Sprint 7): rimossi storeTrucks/truck_filtered_out/
            // mainMapStopAutocenter — orfani dopo la rimozione dei metodi $refs (Fase 5).
        }),
        ...mapGetters({
            focus_truck: 'getFocusTruck',
            // REFACTOR-009: O(1) lookup id→truck dal getter store-derived
            trucksMap: 'trucksMap'
        })
    },
    methods: {
        // REFACTOR-007 (Sprint 7, Fase 5): rimossi truckFocus/lostFocus/truckActivity/
        // truckPlanner/utilsPanel/lostUtilsPanel/boundVisibleTruck. Erano codice morto:
        // GeoFleetMobile rende mappa e pannello via <router-view> senza ref e senza
        // wiring di eventi, quindi i $refs.map/$refs.main_panel erano sempre undefined
        // e nessun entry point invocava questi metodi. Il flusso focus mobile reale e'
        // in MainPanel.emitFocusEvent (setFocusTruck + router.push ai dettagli).
        toggleUtilityPanel(panel) {
            if (this.utility_panel == panel) return

            if (this.activity_panel) this.activity_panel = null

            if (this.searchResourcesPanelOpen) this.$store.commit('toggleSearchResourcePanel')

            if (panel)
                if (this.utility_panel) {
                    this.utility_panel = null

                    setTimeout(() => {
                        this.utility_panel = panel
                    }, 300)
                } else {
                    this.utility_panel = panel
                }
            else this.utility_panel = null
        },
        computeActivity(lastpoint) {
            if (lastpoint.speed || lastpoint.tacho_speed) return 'moving'

            if (lastpoint.engine_rpm) return 'engine_on'

            if (lastpoint.ignition) return 'ignition'

            return 'off'
        },
        loadPoisList(pois) {
            this.pois = pois
        },
        loadTrucks(sb) {
            this.last_update = moment.utc().toISOString()

            this.$fetch(
                this.$env.GOLIA_API +
                    '/trucks?include[]=lastpoint&include[]=details&include[]=category&include[]=tags&filter[VISIBILE][eq]=1'
            )
                .then((res) => {
                    return res.json()
                })
                .then((res) => {
                    sb.done('trucks', res.data)
                })
        },
        loadDrivers(sb) {
            this.$fetch(this.$env.GOLIA_API + '/geofleet/drivers')
                .then((res) => {
                    return res.json()
                })
                .then((res) => {
                    sb.done('drivers', res.data)
                })
        },
        loadProfiles(sb) {
            this.$fetch(this.$env.GOLIA_API + '/geofleet/profiles')
                .then((res) => {
                    return res.json()
                })
                .then((res) => {
                    sb.done('profiles', res.data)
                })
        },
        loadProveniences(sb) {
            this.$fetch(this.$env.GOLIA_API + '/proveniences')
                .then((res) => {
                    return res.json()
                })
                .then((res) => {
                    sb.done('proveniences', res.data)
                })
        },
        loadCompanies(sb) {
            this.$fetch(this.$env.GOLIA_API + '/companies')
                .then((res) => {
                    return res.json()
                })
                .then((res) => {
                    let companies = {}

                    companies[res.data.company.id] = res.data.company.business_name

                    for (var cmpny of res.data.master_slave) {
                        companies[cmpny.id] = cmpny.business_name
                    }

                    this.companies = companies

                    sb.done('companies', companies)
                })
        },
        fetchAndAddTruck(truckId) {
            // BUG-011: porting da GeoFleet desktop (BUG-006).
            // Recovery fire-and-forget per un truck non in trucks_ref: invece di
            // location.reload() (che butta fuori l'utente dalla sessione mobile),
            // fetcha il singolo truck e lo inietta in trucks_ref + store. Lag massimo
            // 20s (al prossimo polling), ma sessione preservata.
            // Dedup tramite Set per evitare fetch concorrenti dello stesso id.
            if (!this._pendingTruckFetches) this._pendingTruckFetches = new Set()
            if (this._pendingTruckFetches.has(truckId)) return
            this._pendingTruckFetches.add(truckId)

            this.$fetch(
                this.$env.GOLIA_API +
                    '/trucks?include[]=lastpoint&include[]=details&include[]=category&include[]=tags&filter[VISIBILE][eq]=1&filter[id][eq]=' +
                    truckId
            )
                .then((res) => res.json())
                .then((res) => {
                    const v = (res.data || []).find((x) => x && x.lastpoint && x.visible)
                    if (!v) {
                        console.warn('BUG-011 mobile recovery: truck not returned or invalid', {
                            truckId
                        })
                        return
                    }

                    // REFACTOR-017: hydration condivisa con created bootstrap.
                    this.hydrateTruck(v, this._truckIndexCounter++)

                    // REFACTOR-009: niente più scrittura `trucks_ref[v.id] = v`.
                    // appendTruck mutation clona shallow il payload e popola
                    // state.trucks; il getter trucksMap deriva da quello.
                    this.$store.commit('appendTruck', v)
                    // REFACTOR-009: rimosso commit setTrucksRef. Consumer cross-file
                    // (VehiclesCrossResults) usano ora trucksMap (vedi Sprint 6 Fase 2A).
                })
                .catch((err) => {
                    console.warn('BUG-011 mobile recovery: truck fetch failed', { truckId, err })
                })
                .finally(() => {
                    if (this._pendingTruckFetches) this._pendingTruckFetches.delete(truckId)
                })
        },
        updateData() {
            // BUG-019: guard contro bootstrap-race (vedi commento in sb.finally del created()).
            // Senza questa guard, polling pre-bootstrap → tutti i truck via fetchAndAddTruck
            // → setTrucks finale wipe i recovered → zombie in trucks_ref.
            if (!this._bootstrapComplete) return

            let query = new URLSearchParams(
                this.last_update ? { update: this.last_update } : ''
            ).toString()

            this.last_update = moment.utc().toISOString()

            this.$fetch(this.$env.GOLIA_API + '/geofleet/lastpoints' + (query ? '?' + query : ''))
                .then((res) => {
                    return res.json()
                })
                .then((res) => {
                    res.data.forEach((p) => {
                        // REFACTOR-009: lookup id→truck via trucksMap (O(1))
                        const existingTruck = this.trucksMap.get(p.truck)
                        if (!existingTruck) {
                            // BUG-011: era `location.reload()` → svuotava la sessione mobile
                            // utente. Adesso fetch mirato fire-and-forget (lag max 20s, sessione
                            // preservata). Vedi fetchAndAddTruck.
                            this.fetchAndAddTruck(p.truck)
                            return
                        }

                        // REFACTOR-009: build dell'updated truck via spread (no mutation
                        // diretta su existingTruck, che è una reference dentro state.trucks).
                        // updateTruck mutation clona il payload prima di assegnarlo.
                        const updatedTruck = {
                            ...existingTruck,
                            activity_type: this.computeActivity(p),
                            lastpoint: this.bindLastPointRelations(p)
                        }

                        this.$store.commit('updateTruck', { truck: updatedTruck })
                    })
                })
        },
        updateTruckTags(tags, truck) {
            this.$store.commit('updateTruckProperty', {
                truck: truck,
                property: 'tags',
                value: tags
            })
        },
        // REFACTOR-017: hydration mobile, parallela a GeoFleet desktop.
        // Mobile non ha visible_on_map/visible_on_list (concetti desktop-only).
        // Assorbe BUG-007 (typo v.length → v.details.length) e REFACTOR-012
        // (counter atomico, eliminato Object.keys(trucks_ref).length).
        hydrateTruck(v, index) {
            v.visible = true
            v.on_focus = false
            v.pinned = false
            v.on_activity = false
            v.index = index
            v.details = v.details
                ? v.details.length === 1
                    ? v.details[0]
                    : v.details.find((d) => d.id_main_descr == 0)
                : null
            v.activity_type = this.computeActivity(v.lastpoint)
            v.profile = this.profiles[v.details ? v.details.profile_id : null]
            v.lastpoint = this.bindLastPointRelations(v.lastpoint)
            return v
        },
        bindLastPointRelations(lastpoint) {
            // BUG-012: porting da GeoFleet desktop. Le mutation setDrivers/setCompanies
            // deep-freezano in place i shared inner objects (lo spread shallow del mutation
            // crea wrapper unfrozen ma cammina le foglie comuni con questa view), quindi
            // assegnare `this.drivers[id]` direttamente passa una reference frozen ai
            // consumer (PlannerPanelContents, DriversSelection) che la mutano → TypeError.
            // Clone shallow + guard BUG-010: se l'id non è in collezione, null (non `{}`).
            lastpoint.provenience =
                lastpoint.provenience && this.proveniences[lastpoint.provenience]
                    ? { ...this.proveniences[lastpoint.provenience] }
                    : null
            lastpoint.driver =
                lastpoint.driver && this.drivers[lastpoint.driver]
                    ? { ...this.drivers[lastpoint.driver] }
                    : null
            lastpoint.last_driver =
                lastpoint.last_driver && this.drivers[lastpoint.last_driver]
                    ? { ...this.drivers[lastpoint.last_driver] }
                    : null
            lastpoint.codriver =
                lastpoint.codriver && this.drivers[lastpoint.codriver]
                    ? { ...this.drivers[lastpoint.codriver] }
                    : null
            lastpoint.company_name = this.companies[lastpoint.company] || ''

            try {
                lastpoint.telemetry =
                    (typeof lastpoint.telemetry === 'string'
                        ? JSON.parse(lastpoint.telemetry)
                        : lastpoint.telemetry) || {}
            } catch (err) {
                lastpoint.telemetry = {}
            }

            return lastpoint
        },
        ...mapActions({
            fitBoundsOfMap: 'fitBoundsOfMap'
        }),
        ...mapMutations({
            focusResource: 'focusResource',
            collapsePanel: 'collapsePanel',
            expandPanel: 'expandPanel'
        })
    },
    created() {
        let _this = this
        this.loading = true

        let sb = {
            counter: 0,
            processes: 5,
            data: {},

            done: function (key, data) {
                this.counter += 1

                this.data[key] = data

                if (this.counter >= this.processes) this.finally()
            },
            finally: function () {
                _this.loading = false

                _this.drivers = this.data['drivers'].reduce((c, d) => {
                    c[d.id] = d

                    return c
                }, {})

                _this.proveniences = this.data['proveniences'].reduce((c, d) => {
                    c[d.id] = d

                    return c
                }, {})

                _this.profiles = this.data['profiles'].reduce((c, d) => {
                    c[d.id] = d

                    return c
                }, {})

                // REFACTOR-017 + REFACTOR-012: counter atomico condiviso con
                // fetchAndAddTruck recovery.
                _this._truckIndexCounter = 0

                // REFACTOR-009 (+ BUG-005 mobile parity): `_this.trucks` era una
                // ghost property non dichiarata in data() — usata solo qui, ora
                // `let trucks` locale. E niente più `_this.trucks_ref[v.id] = v`
                // (single source = state.trucks via getter trucksMap).
                const trucks = this.data['trucks']
                    .filter((v) => {
                        return v.lastpoint && v.visible
                    })
                    .map((v) => {
                        _this.hydrateTruck(v, _this._truckIndexCounter++)
                        return v
                    })

                _this.$store.commit('setTrucks', trucks)
                // REFACTOR-009: rimosso commit setTrucksRef (vedi fetchAndAddTruck).
                _this.$store.commit('setDrivers', _this.drivers)
                _this.$store.commit('setCompanies', _this.companies)

                // BUG-019: stesso problema di desktop. Su bootstrap lento (>20s),
                // l'interval di polling (linea ~507) può sparare prima del finally:
                // tutti i truck cadono in fetchAndAddTruck → appendTruck → poi
                // setTrucks() wipe i recovered, ma trucks_ref li mantiene → zombie.
                _this._bootstrapComplete = true

                // Deep-link: if the app is opened directly on a vehicle route
                // (refresh, share link), seed focus_truck from the URL so pages
                // like PlafondPage can resolve their `truck` once bootstrap is
                // done. If the id doesn't match any loaded truck, fall back to
                // the index.
                if (_this.$route.params.id) {
                    const truck = trucks.find(t => t.plate === _this.$route.params.id)
                    if (truck) {
                        _this.$store.commit('setFocusTruck', { truck, on_focus: true })
                    } else {
                        _this.$router.push({ name: 'geofleet.index' })
                    }
                }
            }
        }

        this.loadDrivers(sb)
        this.loadProfiles(sb)
        this.loadProveniences(sb)
        this.loadCompanies(sb)
        this.loadTrucks(sb)

        //Load common configs from Vuex
        // Sprint 19 (REFACTOR-030): direttamente `config/load`, UNIFORMATO al desktop —
        // il legacy Mobile non passava company_id (divergenza nota, design §7).
        this.$store.dispatch('config/load', {
            companyId: this.$store.state.loggedUser.params.Azienda || null
        })

        //Load company tags
        this.$store.dispatch('loadCompanyTags', this)
        this.$store.dispatch('loadPoiCategories', { vueInstance: this })

        //Load drivers data
        this.$store.dispatch('loadDriversData', { vueInstance: this })

        setInterval(() => {
            if (this.$isBrowserWindowActive()) this.updateData()
        }, 20 * 1000)

        setInterval(() => {
            if (this.$isBrowserWindowActive())
                this.$store.dispatch('loadDriversData', {
                    vueInstance: this,
                    update: moment.utc().toISOString()
                })
        }, 300 * 1000)

        setTimeout(() => {
            if (this.loading) this.loadingTimeout = true
        }, 20000)

        // Config Bus (Sprint 19, REFACTOR-030): parità con GeoFleet.vue. I writer di
        // config persistono con un flush DEBOUNCED (~600ms). Senza questo hook, chi
        // chiude/ricarica la tab entro la finestra perde il burst pendente (sort, pin,
        // filtri) — regressione vs il vecchio `saveConfig` (POST immediato). Flush
        // best-effort su `beforeunload`; la navigazione SPA è coperta da beforeDestroy.
        this._configFlushOnUnload = () => this.$store.dispatch('config/flush')
        window.addEventListener('beforeunload', this._configFlushOnUnload)
    },
    beforeDestroy() {
        // Config Bus (Sprint 19): flush del config pendente prima di lasciare la view
        // via navigazione SPA, poi rimozione del listener di unload.
        this.$store.dispatch('config/flush')
        if (this._configFlushOnUnload) {
            window.removeEventListener('beforeunload', this._configFlushOnUnload)
            this._configFlushOnUnload = null
        }
    },
    watch: {
        $route(to, from) {
            if (to.name == 'geofleet.index') {
                if (this.focus_truck)
                    this.$store.commit('setFocusTruck', {
                        truck: this.focus_truck,
                        on_focus: false
                    })
            }
        }
    }
}
</script>

<style scoped lang="scss">
@use './GeoFleet.scss';
</style>
